<p-select
  #dropDown
  class="b1"
  [(ngModel)]="value"
  (ngModelChange)="handleValueChange($event)"
  [options]="options"
  [style.min-width]="width || '11.25rem'"
  [style.width]="width"
  [style.height]="height || '2rem'"
  [optionValue]="optionValue"
  [optionLabel]="optionLabel"
  [optionDisabled]="optionDisabled"
  [disabled]="disabled() || disabledState()"
  [editable]="editable"
  [placeholder]="placeholder()"
  [appendTo]="appendTo()"
  [resetFilterOnHide]="resetFilterOnHide"
  (onChange)="onChange.emit($event)"
  (onShow)="onShow.emit()"
  (onHide)="onHide.emit($event)"
  (onClick)="onClick.emit($event)"
  [group]="group"
  [filter]="filter"
  [filterBy]="filterBy || 'label'"
  [filterPlaceholder]="filterPlaceholder"
  [showClear]="showClear"
  [focusOnHover]="false"
  [styleClass]="styleClass"
  [panelStyleClass]="panelStyleClass">
  @if (customTemplate) {
    <ng-template let-option pTemplate="item">
      <ng-container
        *ngTemplateOutlet="
          customTemplate;
          context: { $implicit: option }
        "></ng-container>
    </ng-template>
  }
  @if (customSelectedTemplate) {
    <ng-template let-value pTemplate="selectedItem">
      <ng-container
        *ngTemplateOutlet="
          customSelectedTemplate;
          context: { $implicit: value }
        "></ng-container>
    </ng-template>
  }
  @if (customGroupTemplate) {
    <ng-template let-group pTemplate="group">
      <ng-container
        *ngTemplateOutlet="
          customGroupTemplate;
          context: { $implicit: group }
        "></ng-container>
    </ng-template>
  }
  @if (customFooterTemplate) {
    <ng-template pTemplate="footer">
      <ng-container *ngTemplateOutlet="customFooterTemplate"></ng-container>
    </ng-template>
  }
  <ng-content></ng-content>
</p-select>
